import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';
import { isEmpty, getformid, getcontroller, getsubkey } from '../modules/appLibrary';

export const Code = props => {

    const dispatch = useDispatch();
    const formid = getformid("Code", props.location.search);
    const controller = getcontroller("Code", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;

    const actionurl = {
        "insert": "code/Insert",
        "update": "code/Update",
        "delete": "code/Delete",
        "saveas": "code/SaveAs",
        "storageadd": "code/AddStorage",
        "storagerowdel": "code/StorageRowdel",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]


    return (
         <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={false}
                navmenu={navmenu}
            />
        </div>
    );
};
